import {  LOG_OUT_USER, SHOW_LOADING } from "../../actions/actionTypes";

const determineLoadingIndicatorState = (currentState, payload) => {
    if (currentState >= 0){
        if (payload){
            currentState += 1;
        }else{
            if ((currentState - 1) >= 0){
                currentState -= 1;
            }
        }
    }

    return currentState
    
}

const loadingIndicatorReducer = (state=0, action) => {
    // Remember to have cases for UPDATE_AUTHORIZED and VERIFY_TOKEN besides the other cases.
    let currentState = state;
    switch(action.type){ 
        case SHOW_LOADING:
            //return action.payload;
            return determineLoadingIndicatorState(currentState, action.payload)
        case LOG_OUT_USER:
            return 0;
        
        default:
            // return false;
            return determineLoadingIndicatorState(currentState, false)
    }
    
};

export default loadingIndicatorReducer;